module.exports = __webpack_public_path__ + "img/monterey-rectangle-high-angle.870c291a.png";